import type { Woonquote } from "@/models/domain/Woonquote";

interface WoonquotePercentages {
	variables: {
		[Box in "box1" | "box3"]: {
			variables: {
				[AOWStatus in "welAOW" | "nietAOW"]: {
					values: Record<
						string,
						{
							value: Woonquote;
						}
					>;
				};
			};
		};
	};
}

export const woonquotePercentages: WoonquotePercentages = {
	variables: {
		box1: {
			variables: {
				welAOW: {
					values: {
						"2021-01-01": {
							value: undefined,
						},
						"2022-01-01": {
							value: undefined,
						},
						"2023-01-01": {
							value: undefined,
						},
						"2024-01-01": {
							value: undefined,
						},
					},
				},
				nietAOW: {
					values: {
						"2021-01-01": {
							value: undefined,
						},
						"2022-01-01": {
							value: undefined,
						},
						"2023-01-01": {
							value: undefined,
						},
						"2024-01-01": {
							value: undefined,
						},
					},
				},
			},
		},
		box3: {
			variables: {
				welAOW: {
					values: {
						"2021-01-01": {
							value: undefined,
						},
						"2022-01-01": {
							value: undefined,
						},
						"2023-01-01": {
							value: undefined,
						},
						"2024-01-01": {
							value: undefined,
						},
					},
				},
				nietAOW: {
					values: {
						"2021-01-01": {
							value: undefined,
						},
						"2022-01-01": {
							value: undefined,
						},
						"2023-01-01": {
							value: undefined,
						},
						"2024-01-01": {
							value: undefined,
						},
					},
				},
			},
		},
	},
};
